import React, { useRef, useState, useEffect } from "react";
import { Modal, Button, Form, Carousel, Input, message } from "antd";
import { Compass, LogoBlack, Fast, GiftCard1, BookingIcon } from "../../../assets/icons";
import { ContactsOutlined, MailOutlined } from "@ant-design/icons";
import { GET_USERS_BY_PHONE, GET_USERS_BY_EMAIL } from "../../../constants";
import { EyeTwoTone, EyeInvisibleOutlined } from "@ant-design/icons";
import { LOGIN_USER, SIGNUP_USER } from "../../../constants";
import { useMutation, useLazyQuery } from "@apollo/client";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import axios from "axios";
import axiosInstance from "../../../utilities/axiosConfig";
import { getCustomerDetails, findCustomerByContact, sendCustomerOTP, verifyCustomerOTP, addUserDirectUrewards, provisionLoyaltyId } from "../../../utilities/customerLoyaltyApi";

const SigninModal = ({
	visible,
	onCancel,
	merchant_rewards_id,
	setNewUser,
	merchant: propMerchant,
	checkInAgain,
	setConfirmGiftCard,
	setCustomerLoyaltyProgram
}) => {
	const [signInForm] = Form.useForm();
	const [signUpForm] = Form.useForm();
	const [value, setValue] = useState("")
	const carouselRef = useRef(null);
	const [shouldSignIn, setShowSignIn] = useState(false);
	const [loading, setLoading] = useState(false);
	const [showOTP, setShowOTP] = useState(false);
	const [messages, setMessage] = useState(null);
	const [showMessage, setShowMessage] = useState(false);
	const [OTP, setOTP] = useState(null);
	const [danger, setDanger] = useState(false);
	const [phoneNo, setPhoneNo] = useState(null);
	const [firstName, setFirstName] = useState(null);
	const [email, setEmail] = useState(null);
	const [userData, setUserData] = useState(null);
	const [isUserFound, setIsUserFound] = useState(true);
	const [whatsappOtp, setWhatsappOtp] = useState(null);
	const [isWhatapp, setIsWhatsapp] = useState(false);
	const [timeLeft, setTimeLeft] = useState(15);
	const [showSendWhatsapp, setShowWhatsapp] = useState(false);
	const [isNewCust, setIsNewCust] = useState(false);

	const merchant = (() => {
		if (propMerchant && typeof propMerchant === "object" && (propMerchant.id || propMerchant.business_name)) {
			return propMerchant;
		}
		if (typeof propMerchant === "number" || (typeof propMerchant === "string" && propMerchant && !isNaN(Number(propMerchant)))) {
			return { id: Number(propMerchant) };
		}
		try {
			const storedStr =
				localStorage.getItem("merchant_details") ||
				localStorage.getItem("urewards_merchant_details");
			if (storedStr) {
				const parsed = JSON.parse(storedStr);
				if (parsed?.id || parsed?.merchant_details?.id) {
					return {
						...parsed,
						id: parsed.id || parsed.merchant_details?.id,
						business_name: parsed.business_name || parsed.merchant_details?.business_name,
						email: parsed.email || parsed.merchant_details?.email,
						image: parsed.image || parsed.logo || parsed.merchant_details?.image || parsed.merchant_details?.logo,
					};
				}
				if (typeof parsed === "object") return parsed;
			}
		} catch (e) {
			console.error("Error reading stored merchant in SigninModal:", e);
		}
		if (merchant_rewards_id && !isNaN(Number(merchant_rewards_id))) {
			return { id: Number(merchant_rewards_id) };
		}
		return null;
	})();

	const getEffectiveMerchantId = (targetUser = null) => {
		return (
			merchant?.id ||
			targetUser?.merchant_id ||
			userData?.merchant_id ||
			(typeof propMerchant === 'number' || (typeof propMerchant === 'string' && !isNaN(Number(propMerchant))) ? Number(propMerchant) : null) ||
			(merchant_rewards_id && !isNaN(Number(merchant_rewards_id)) ? Number(merchant_rewards_id) : null) ||
			null
		);
	};
	const [userCountry, setUserCountry] = useState("us"); // Default to US
	const [contactInput, setContactInput] = useState(""); // Email or Phone
	const [otpMethod, setOTPMethod] = useState("phone"); // 'email' or 'phone'
	const [maskedContact, setMaskedContact] = useState("");
	const [useEmailInput, setUseEmailInput] = useState(false); // Toggle between phone and email input


	const [getUserDetails] = useLazyQuery(GET_USERS_BY_PHONE);
	const [getUserByEmailQuery] = useLazyQuery(GET_USERS_BY_EMAIL);

	useEffect(() => {
		const timerId = setInterval(() => {
			setTimeLeft((prevTime) => prevTime - 1);
		}, 1000);

		if (timeLeft <= 0) {
			setShowWhatsapp(true);
			clearInterval(timerId);
		}

		if (!showOTP) clearInterval(timerId)

		return () => {
			clearInterval(timerId);
		}
	}, [timeLeft, showOTP]);

	// Detect user's country based on geolocation
	useEffect(() => {
		// On component mount, restore OTP session from localStorage if it exists
		const restoreOTPSession = () => {
			try {
				const savedOTPSession = localStorage.getItem('otp_session');
				if (savedOTPSession) {
					const otpSession = JSON.parse(savedOTPSession);
					// Check if OTP session is still valid (not expired)
					const sessionAge = Date.now() - otpSession.timestamp;
					const SESSION_TIMEOUT = 10 * 60 * 1000; // 10 minutes

					if (sessionAge < SESSION_TIMEOUT) {
						setUserData(prev => ({
							...prev,
							otp_id: otpSession.otp_id,
							otp_method: otpSession.otp_method,
							otp_contact: otpSession.otp_contact,
							first_name: otpSession.first_name
						}));
						setShowOTP(true);
						setMaskedContact(otpSession.masked_contact);
						setMessage(otpSession.message);
						setShowMessage(true);
					} else {
						// OTP session expired, clear it
						localStorage.removeItem('otp_session');
					}
				}
			} catch (error) {
				console.log('Error restoring OTP session:', error);
			}
		};

		restoreOTPSession();
	}, [visible]); // Run when modal becomes visible

	// Detect user's country based on geolocation
	useEffect(() => {
		const detectUserCountry = async () => {
			try {
				// First try to get location from IP address
				const response = await fetch('https://ipapi.co/json/');
				const data = await response.json();
				if (data.country_code) {
					setUserCountry(data.country_code.toLowerCase());
					return;
				}
			} catch (error) {
				console.log('IP geolocation failed:', error);
			}

			// Fallback: Try browser geolocation API
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(
					async (position) => {
						try {
							const { latitude, longitude } = position.coords;
							const response = await fetch(
								`https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
							);
							const data = await response.json();
							if (data.countryCode) {
								setUserCountry(data.countryCode.toLowerCase());
							}
						} catch (error) {
							console.log('Reverse geocoding failed:', error);
						}
					},
					(error) => {
						console.log('Geolocation failed:', error);
						// Keep default country (US)
					},
					{ timeout: 10000 }
				);
			}
		};

		detectUserCountry();
	}, []);

	const formatTime = (seconds) => {
		const minutes = Math.floor(seconds / 60);
		const remainingSeconds = seconds % 60;
		//
		return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
	};


	// const merchant = storedMerchant ? JSON.parse(storedMerchant) : "";
	const confirmCloseModal = () =>
		Modal.confirm({
			title: "Are you sure you want to cancel sign-in?",
			onOk: () => {
				// Clear OTP session when closing modal
				localStorage.removeItem('otp_session');
				setShowOTP(false);
				setOTP(null);
				setUserData(null);
				onCancel();
			},
			className: "themed-confirm-modal",
		});

	const handleLogin = () => {
		try {
			signInForm.validateFields().then((values) => {
				loginUser({ variables: { ...values } });
			});
		} catch (error) {
			message.error(error.message);
		}
	};

	const handleSignUp = () => {
		setLoading(true);
		try {
			signUpForm.validateFields().then((values) => {
				let { phone_number } = values;
				phone_number = value;
				delete values.OTP;

				signUpUser({
					variables: {
						data: {
							...values,
							phone_number: phone_number,
							merchant_rewards_id: merchant_rewards_id || "",
							sex: "-",
						},
					},
				});
			});
		} catch (error) {
			setLoading(false)
			message.error(error.message);
		}
	};

	const tempSignIn = () => {
		handleSignUp();
	}

	const handleSignIn = () => {
		const { phone_number } = signUpForm.getFieldsValue();
		if (!phone_number) return message.error("Enter phone number to continue");

		// Use consistent phone number format
		const formattedPhoneNo = phoneNo || `+${phone_number}`;
		setLoading(true);
		getUserDetails({
			variables: {
				phone_number: formattedPhoneNo,
				merchant_id: getEffectiveMerchantId() ? Number(getEffectiveMerchantId()) : null
			},
			onCompleted: (data) => {
				const { message: mess, user } = data.getUserByPhone;
				if (mess === "failed, user does not exist!" || !user) {
					setIsUserFound(false);
					return setLoading(false);
				};

				setIsUserFound(true);
				setLoading(false);
				setUserData(user);
				generateOTP();
				setIsNewCust(false);
			}
		});
	}

	// New unified email/phone login handler
	const handleNewSignIn = async () => {
		if (!contactInput) return message.error("Enter your email or phone number to continue");

		setLoading(true);

		const isEmail = contactInput.includes('@');
		setOTPMethod(isEmail ? 'email' : 'phone');

		if (isEmail) {
			getUserByEmailQuery({
				variables: {
					email: contactInput,
					merchant_id: getEffectiveMerchantId() ? Number(getEffectiveMerchantId()) : null
				},
				onCompleted: async (data) => {
					const { message: mess, user } = data.getUserByEmail;
					if (mess === "failed, user does not exist!" || !user) {
						setIsUserFound(false);
						setLoading(false);
						return;
					}

					setIsUserFound(true);
					setUserData(user);
					setIsNewCust(false);

					const customerId = user.customer_id || user.user_id;
					if (customerId) {
						await handleSendNewOTP(customerId, 'email', contactInput, user);
					} else {
						setLoading(false);
						message.error("Customer ID not found. Please try again.");
					}
				},
				onError: (error) => {
					setLoading(false);
					message.error(error.message || "Failed to find customer. Please try again.");
				}
			});
		} else {
			const formattedPhoneNo = contactInput.startsWith('+') ? contactInput : `+${contactInput}`;
			setPhoneNo(formattedPhoneNo);

			getUserDetails({
				variables: {
					phone_number: formattedPhoneNo,
					merchant_id: getEffectiveMerchantId() ? Number(getEffectiveMerchantId()) : null
				},
				onCompleted: async (data) => {
					const { message: mess, user } = data.getUserByPhone;
					if (mess === "failed, user does not exist!" || !user) {
						setIsUserFound(false);
						setLoading(false);
						return;
					}

					setIsUserFound(true);
					setUserData(user);
					setIsNewCust(false);

					const customerId = user.customer_id || user.user_id;
					if (customerId) {
						await handleSendNewOTP(customerId, 'phone', formattedPhoneNo, user);
					} else {
						setLoading(false);
						message.error("Customer ID not found. Please try again.");
					}
				},
				onError: (error) => {
					setLoading(false);
					message.error(error.message || "Failed to find customer. Please try again.");
				}
			});
		}
	}

	// Initiate signup for new user: generate OTP via phone
	const handleSignUpNewUser = async () => {
		if (!firstName) return message.error("Please enter your first name");
		if (!contactInput) return message.error("Contact information is required");

		// Generate OTP for new user
		const isEmail = contactInput.includes('@');

		if (isEmail) {
			setLoading(true);
			try {
				// We'll create a temporary UserData object with new_user flags 
				// and use the mTier handleSendNewOTP logic
				const tempUserObj = {
					new_user_email: contactInput,
					new_user_first_name: firstName,
					first_name: firstName
				};

				// For new users, we pass 'new_user' as customerId so mTier knows
				// to just send the OTP without checking for existing customer
				const effectiveMId = getEffectiveMerchantId();
				const result = await sendCustomerOTP(effectiveMId, 'new_user', 'email', contactInput);

				if (result.success) {
					const otpSessionData = {
						otp_id: result.data.otp_id,
						otp_method: 'email',
						otp_contact: contactInput,
						masked_contact: result.data.masked_email || contactInput,
						first_name: firstName,
						message: `Please enter the code sent to ${result.data.masked_email || contactInput}`,
						timestamp: Date.now()
					};

					localStorage.setItem('otp_session', JSON.stringify(otpSessionData));

					setUserData(prev => ({
						...prev,
						...tempUserObj,
						...otpSessionData
					}));
					setLoading(false);
					setShowOTP(true);
					setMaskedContact(otpSessionData.masked_contact);
					setMessage(otpSessionData.message);
					setShowMessage(true);
					setDanger(false);
				} else {
					setLoading(false);
					message.error("Failed to send OTP. Please try again.");
				}
			} catch (error) {
				setLoading(false);
				message.error(error.message || "Failed to send OTP. Please try again.");
			}
		} else {
			const formattedPhoneNo = phoneNo || `+${contactInput}`;
			setLoading(true);
			try {
				// For phone numbers, we use the original Rails endpoint 
				// which integrates with the original registration flow
				const payload = {
					phone_number: formattedPhoneNo,
					email: merchant?.email || ''
				};

				const res = await axios.put(`${process.env.REACT_APP_BASE_URL}/api/v2/generate_phone_verification_token`, payload, {
					headers: {
						'Content-Type': 'application/json',
						'Accept': 'application/json'
					}
				});

				if (res.status === 200) {
					setLoading(false);
					const msgText = `Please enter the code sent to ${formattedPhoneNo}`;
					setShowOTP(true);
					setMessage(msgText);
					setShowMessage(true);
					setDanger(false);
					// Store info for post-OTP verification
					setUserData(prev => ({
						...prev,
						new_user_phone: formattedPhoneNo,
						new_user_first_name: firstName
					}));
				}
			} catch (error) {
				setLoading(false);
				const errorMsg = error?.response?.data?.message || "Failed to send OTP. Please try again.";
				message.error(errorMsg);
			}
		}
	}

	// Send OTP via new mTier endpoint (email or phone)
	const handleSendNewOTP = async (customerId, method, contact, userObj = null) => {
		try {
			const effectiveMId = getEffectiveMerchantId(userObj || userData);
			const result = await sendCustomerOTP(effectiveMId, customerId, method, contact);

			if (result.success) {
				// Use passed userObj or fall back to userData state
				const currentUser = userObj || userData;
				const firstName = currentUser?.first_name || 'Customer';

				const otpSessionData = {
					otp_id: result.data.otp_id,
					otp_method: method,
					otp_contact: contact,
					masked_contact: result.data.masked_email || result.data.masked_phone || contact,
					first_name: firstName,
					message: `Please enter the code sent to ${result.data.masked_email || result.data.masked_phone || contact}`,
					timestamp: Date.now()
				};

				// Save OTP session to localStorage for persistence across page refreshes
				localStorage.setItem('otp_session', JSON.stringify(otpSessionData));

				setUserData(prev => ({
					...prev,
					...otpSessionData,
					first_name: firstName
				}));
				setLoading(false);
				setShowOTP(true);
				setMaskedContact(otpSessionData.masked_contact);
				setMessage(otpSessionData.message);
				setShowMessage(true);
				setDanger(false);
				message.success(result.message || "OTP sent successfully!");
			} else {
				setLoading(false);
				message.error("Failed to send OTP. Please try again.");
			}
		} catch (error) {
			setLoading(false);
			message.error(error.message || "Failed to send OTP. Please try again.");
		}
	}

	// Verify OTP via mTier endpoint
	const handleVerifyNewOTP = async () => {
		if (!OTP) return message.error("Enter OTP to continue");

		let otpId = userData?.otp_id;
		let otpMethod = userData?.otp_method;
		let otpContact = userData?.otp_contact;
		let firstName = userData?.first_name;

		// Fallback: If otp_id not in state, try to restore from localStorage
		if (!otpId) {
			try {
				const savedOTPSession = localStorage.getItem('otp_session');
				if (savedOTPSession) {
					const otpSession = JSON.parse(savedOTPSession);
					const sessionAge = Date.now() - otpSession.timestamp;
					const SESSION_TIMEOUT = 10 * 60 * 1000; // 10 minutes

					if (sessionAge < SESSION_TIMEOUT) {
						otpId = otpSession.otp_id;
						otpMethod = otpSession.otp_method;
						otpContact = otpSession.otp_contact;
						firstName = otpSession.first_name;
						// Also restore to state so it's available
						setUserData(prev => ({
							...prev,
							otp_id: otpId,
							otp_method: otpMethod,
							otp_contact: otpContact,
							first_name: firstName
						}));
					}
				}
			} catch (error) {
				console.log('Error restoring OTP session from localStorage:', error);
			}
		}

		if (!otpId) return message.error("OTP session expired. Please request a new code.");
		if (!otpMethod || !otpContact) return message.error("Contact information missing. Please try again.");

		setLoading(true);
		try {
			const effectiveMId = getEffectiveMerchantId(userData);
			const result = await verifyCustomerOTP(effectiveMId, otpId, OTP, otpMethod, otpContact);

			if (result.success) {
				// For new users, create them in the system after OTP verification
				if (!isUserFound && (userData?.new_user_first_name || firstName)) {
					try {
						const activeMerchantId = effectiveMId;
						const newUserData = await addUserDirectUrewards(
							activeMerchantId,
							userData?.new_user_first_name || firstName,
							otpMethod === 'email' ? otpContact : (userData?.new_user_email || ""),
							otpMethod === 'phone' ? otpContact : (userData?.new_user_phone || "")
						);

						if (newUserData.status === "success" || newUserData.status !== "error") {
							const createdUser = newUserData.data || newUserData.user || newUserData;
							const enrichedCreatedUser = await fetchCustomerLoyaltyData(createdUser);
							const userWithToken = {
								...enrichedCreatedUser,
								token: result.data?.token || ""
							};
							setLoading(false);
							setNewUser(userWithToken);
							localStorage.setItem("user_customer_details", JSON.stringify(userWithToken));
							if (result.data?.token) localStorage.setItem("customer_auth_token", result.data.token);
							localStorage.removeItem('otp_session');

							const displayName = userWithToken?.first_name || 'Customer';
							message.success(`${displayName}, you have been checked in successfully`);
							!!checkInAgain && checkInAgain();
							onCancel();
							return;
						} else {
							throw new Error(newUserData.errors?.full_messages?.[0] || "Failed to create user");
						}
					} catch (createError) {
						setLoading(false);
						message.error(createError.message || "Failed to register user. Please try again.");
						return;
					}
				}

				localStorage.setItem("customer_auth_token", result.data.token);
				// Clear OTP session after successful verification
				localStorage.removeItem('otp_session');

				const enrichedUserData = await fetchCustomerLoyaltyData(userData);
				setNewUser(enrichedUserData);
				localStorage.setItem("user_customer_details", JSON.stringify(enrichedUserData));

				if (setCustomerLoyaltyProgram && enrichedUserData.loyalty_points) {
					setCustomerLoyaltyProgram(enrichedUserData.loyalty_points);
				}

				setLoading(false);
				// Use firstName variable which was restored if needed
				const displayName = firstName || userData?.first_name || 'Customer';
				message.success(`${displayName}, you have been checked in successfully`);
				!!checkInAgain && checkInAgain();
				onCancel();
			} else {
				setLoading(false);
				setDanger(true);
				setMessage("Invalid or expired OTP. Please try again.");
				message.error("Invalid or expired OTP. Please try again.");
			}
		} catch (error) {
			setLoading(false);
			setDanger(true);
			const errorMessage = error.message || "OTP verification failed. Please check your code and try again.";
			setMessage(errorMessage);
			message.error(errorMessage);
		}
	}

	// Helper to enrich user data with loyalty info after login
	const fetchCustomerLoyaltyData = async (userData) => {
		try {
			const contact = userData?.otp_contact || userData?.phone_number || userData?.email || phoneNo || email;
			const activeMerchantId = merchant?.id || (typeof merchant === 'number' || typeof merchant === 'string' ? merchant : null) || merchant_rewards_id;
			let fetchedLoyaltyId = (userData?.loyalty_id && String(userData.loyalty_id).length >= 8 && !String(userData.loyalty_id).startsWith('LOY-'))
				? String(userData.loyalty_id)
				: null;
			let currentCustomerId = userData?.customer_id || userData?.user_id || userData?.id;

			if (activeMerchantId && contact) {
				try {
					const customerRecord = await findCustomerByContact(activeMerchantId, contact);
					if (customerRecord?.loyalty_id && String(customerRecord.loyalty_id).length >= 8) {
						fetchedLoyaltyId = String(customerRecord.loyalty_id);
					}
					if (customerRecord?.id) {
						currentCustomerId = customerRecord.id;
					}
				} catch (err) {
					console.error("Error fetching customer loyalty_id in SigninModal:", err);
				}
			}

			// If still missing loyalty ID, provision one atomically
			if (!fetchedLoyaltyId && activeMerchantId && currentCustomerId) {
				try {
					const provisioned = await provisionLoyaltyId(activeMerchantId, currentCustomerId);
					if (provisioned && String(provisioned).length >= 8) {
						fetchedLoyaltyId = String(provisioned);
					}
				} catch (err) {
					console.error("Error provisioning loyalty_id in SigninModal:", err);
				}
			}

			if (userData?.loyalty_points) {
				const simplePoints = userData.loyalty_points.simple_points?.[0]?.accumulated_points || 0;
				const stampsCount = userData.loyalty_points.stamps_program?.[0]?.accumulated_stamps || 0;
				return {
					...userData,
					id: currentCustomerId || userData.id,
					customer_id: currentCustomerId || userData.customer_id,
					loyalty_id: fetchedLoyaltyId || null,
					merchant_id: activeMerchantId || userData.merchant_id,
					total_points: simplePoints,
					total_stamps: stampsCount
				};
			}
			if (currentCustomerId) {
				const loyaltyData = await getCustomerDetails(currentCustomerId);
				return {
					...userData,
					id: currentCustomerId || userData.id,
					customer_id: currentCustomerId || userData.customer_id,
					loyalty_id: fetchedLoyaltyId || null,
					merchant_id: activeMerchantId || userData.merchant_id,
					loyalty_points: { simple_points: loyaltyData.points || [], stamps_program: loyaltyData.tiers || [] },
					total_points: Math.floor(loyaltyData.points?.reduce((sum, p) => sum + (Number(p.points_value) || 0), 0) || 0)
				};
			}
		} catch (error) {
			console.error("Error fetching customer loyalty data:", error);
		}
		return { ...userData, loyalty_id: userData?.loyalty_id };
	};

	const generateOTP = () => {
		const { phone_number } = signUpForm.getFieldsValue();
		if (!phone_number) return message.error("Enter phone number to continue");

		// Use consistent phone number format - use phoneNo which is already properly formatted
		const formattedPhoneNo = phoneNo || `+${phone_number}`;

		// Use JSON payload instead of FormData to avoid protocol issues
		const payload = {
			phone_number: formattedPhoneNo,
			email: merchant?.email || ''
		};

		console.log("=== OTP Generation Debug ===");
		console.log("Phone number:", formattedPhoneNo);
		console.log("Merchant email:", merchant?.email);
		console.log("Full merchant object:", merchant);
		console.log("Payload:", payload);
		console.log("API URL:", `${process.env.REACT_APP_BASE_URL}/api/v2/generate_phone_verification_token`);

		setLoading(true);
		axios.put(`${process.env.REACT_APP_BASE_URL}/api/v2/generate_phone_verification_token`, payload, {
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json'
			}
		})
			.then((res) => {
				console.log("OTP Generation Response:", res);
				console.log("Full response data:", res.data);
				if (res.status === 200) {
					setLoading(false);
					const message = `Please enter the code sent to ${formattedPhoneNo}`;
					setShowOTP(true);
					setMessage(message);
					setShowMessage(true);
				}
			})
			.catch((err) => {
				setLoading(false)
				console.error("OTP Generation Error:", err);
				console.error("Error response:", err.response);
				setDanger(true);
				const errorMessage = err?.response?.data?.message || "Failed to send OTP. Please try again.";
				setMessage(errorMessage);
				setShowMessage(true);
				message.error(errorMessage); // Show toast error message
			})
	}

	const generateOTPViaWhatsapp = () => {
		const { phone_number } = signUpForm.getFieldsValue();
		if (!phoneNo) return message.error("Enter phone number to continue");

		// Use consistent phone number format
		const formattedPhoneNo = phoneNo || `+${phone_number}`;

		const payload = {
			phoneNo: formattedPhoneNo,
			email: merchant?.email || ''
		};

		setLoading(true);
		axios.post(`${process.env.REACT_APP_MULTI_LEVEL_BASE_URL}/verify_whatsapp_otp`, payload, {
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json'
			}
		})
			.then((res) => {
				console.log("WhatsApp OTP Response:", res);
				if (res.status === 200) {
					setLoading(false);
					const message = `Please enter the code sent to ${formattedPhoneNo}`;
					setWhatsappOtp(res.data.otp);
					setIsWhatsapp(true);
					setShowOTP(true);
					setMessage(message);
					setShowMessage(true);
					setTimeLeft(15);
					setShowWhatsapp(false);
				}
			})
			.catch((err) => {
				setLoading(false)
				console.error("WhatsApp OTP Error:", err);
				setDanger(true);
				const errorMessage = err?.response?.data?.message || "Failed to send WhatsApp OTP. Please try again.";
				setMessage(errorMessage);
				setShowMessage(true);
				message.error(errorMessage); // Show toast error message
			})
	}//

	const confirmWhatsappOtp = () => {
		if (!OTP) return message.error("Enter otp to continue");
		if (!phoneNo) return message.error("Enter phone number to continue");

		// Use consistent phone number format
		const formattedPhoneNo = phoneNo;

		const payload = {
			phone_number: formattedPhoneNo,
			code: OTP
		};

		setLoading(true);
		axios.put(`${process.env.REACT_APP_BASE_URL}/api/v2/verify_merchant_phone_number`, payload, {
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json'
			}
		})
			.then((res) => {
				console.log("WhatsApp OTP Verification Response:", res);
				if (res.status === 200) {
					setLoading(false)
					setShowMessage(true);
					if (!isUserFound) {
						setDanger(false);
						setMessage(null);
						return handleSignUp();
					}
					// Merge token from response with userData if available
					const userWithToken = {
						...userData,
						token: res.data?.token || res.data?.data?.token || userData?.token
					};
					setNewUser(userWithToken);
					localStorage.setItem("user_customer_details", JSON.stringify(userWithToken))
					message.success(
						`${userWithToken?.first_name}, you have been checked in successfully`
					);
					!!checkInAgain && checkInAgain();
					return onCancel();
				}
			})
			.catch((err) => {
				console.error("WhatsApp OTP Verification Error:", err);
				setDanger(true);
				setLoading(false)
				const errorMessage = err?.response?.data?.message || err?.response?.data || err.message || "WhatsApp OTP verification failed. Please check your code and try again.";
				setMessage(errorMessage);
				setShowMessage(true);
				message.error(errorMessage); // Show toast error message
			})
	}

	const handleConfirmOTP = () => {
		// const { phone_number } = signUpForm.getFieldsValue();
		if (!OTP) return message.error("Enter otp to continue");

		// If this is an email OTP session (either from handleNewSignIn or handleSignUpNewUser via mTier)
		if (userData?.otp_method === 'email' || (contactInput && contactInput.includes('@') && !phoneNo)) {
			return handleVerifyNewOTP();
		}

		if (!phoneNo) return message.error("Enter phone number to continue");

		// Use consistent phone number format
		const formattedPhoneNo = phoneNo;

		// Use JSON payload instead of FormData to avoid protocol issues
		const payload = {
			phone_number: formattedPhoneNo,
			code: OTP
		};

		if (isWhatapp) {
			return confirmWhatsappOtp();
		}
		setLoading(true);
		axios.put(`${process.env.REACT_APP_BASE_URL}/api/v2/verify_merchant_phone_number`, payload, {
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json'
			}
		})
			.then(async (res) => {
				console.log("OTP Verification Response:", res);
				console.log("Full verification response data:", res.data);
				if (res.status === 200) {
					// For new users, create them in the system after OTP verification
					if (!isUserFound && userData?.new_user_first_name) {
						try {
							const effectiveMId = getEffectiveMerchantId(userData);
							const newUserData = await addUserDirectUrewards(
								effectiveMId,
								userData.new_user_first_name,
								userData.new_user_email || "",
								userData.new_user_phone
							);

							if (newUserData.status === "success" || newUserData.status !== "error") {
								const createdUser = newUserData.data || newUserData.user || newUserData;
								const userWithToken = {
									...createdUser,
									token: res.data?.token || res.data?.data?.token || ""
								};
								setLoading(false);
								setNewUser(userWithToken);
								localStorage.setItem("user_customer_details", JSON.stringify(userWithToken));
								message.success(`${userWithToken?.first_name}, you have been checked in successfully`);
								!!checkInAgain && checkInAgain();
								onCancel();
								return;
							} else {
								throw new Error(newUserData.errors?.full_messages?.[0] || "Failed to create user");
							}
						} catch (createError) {
							setLoading(false);
							message.error(createError.message || "Failed to register user. Please try again.");
							return;
						}
					}

					setLoading(false)
					setMessage(res.data.message);
					setShowMessage(true);
					// Merge token from response with userData if available
					const userWithToken = {
						...userData,
						token: res.data?.token || res.data?.data?.token || userData?.token
					};
					setNewUser(userWithToken);
					localStorage.setItem("user_customer_details", JSON.stringify(userWithToken))
					message.success(
						`${userWithToken?.first_name}, you have been checked in successfully`
					);
					!!checkInAgain && checkInAgain();
					onCancel();
				}
			})
			.catch((err) => {
				console.error("OTP Verification Error:", err);
				setDanger(true);
				setLoading(false);
				const errorMessage = err?.response?.data?.message || err?.response?.data || err.message || "OTP verification failed. Please check your code and try again.";
				setMessage(errorMessage);
				setShowMessage(true);
				message.error(errorMessage); // Show toast error message
			})
	}

	const [loginUser, { loading: isLoginLoading }] = useMutation(LOGIN_USER, {
		onCompleted: (data) => {
			if (!!data.loginUser) {
				localStorage.setItem(
					"user_customer_details",
					JSON.stringify(data.loginUser)
				);
				setNewUser(data.loginUser);
				onCancel();
				Modal.success({
					title: "Login Successful",
					onOk: onCancel,
				});
			}
		},
		onError: (error) => {
			message.error(error.message, 5);
		},
	});

	const [signUpUser, { loading: isSignUpLoading }] = useMutation(SIGNUP_USER, {
		onCompleted: (data) => {
			if (data.signUpUser) {
				setLoading(false);
				setIsUserFound(true);
				setUserData(data.signUpUser);
				generateOTP();
				setIsNewCust(true);
				// setNewUser(data.signUpUser);
				// message.success(
				// 	`${data.signUpUser?.first_name}, you have been checked in successfully`
				// );
				// !!checkInAgain && checkInAgain();
				// onCancel();
			}
		},
		onError: (error) => {
			setLoading(false);
			message.error(error.message, 5);
		},
	});

	// const goNext = () => carouselRef.current.next();
	// const goPrev = () => carouselRef.current.prev();

	return (
		<Modal
			open={visible}
			footer={[]}
			className="login_modal"
			onCancel={confirmCloseModal}
			style={{ top: 20 }}
		>
			<Carousel ref={carouselRef} dots={false}>
				<div className="sign_up_content">
					<div className="flex_center">
						<img
							style={{ width: 56, maxHeight: 56, objectFit: "contain" }}
							src={merchant?.image || LogoBlack}
							alt="merchant logo"
						/>
					</div>
					<h2
						className="title_text"
						style={{
							color: "#6B6A6A",
							marginTop: "4px",
							marginBottom: 0,
							fontWeight: 600,
							fontSize: "18px",
							textAlign: "center",
						}}>
						{merchant?.business_name || ""}
					</h2>
					{!userData && <h2
						className="title_text"
						style={{
							color: "#000",
							fontWeight: 600,
							fontSize: "24px",
							textAlign: "center",
							margin: "4px 0 6px 0",
						}}>
						👋🏽 Welcome
					</h2>}
					{userData && <h2
						className="title_text"
						style={{
							color: "#000",
							fontWeight: 600,
							fontSize: "24px",
							textAlign: "center",
							margin: "4px 0 6px 0",
						}}>
						👋🏽 {isNewCust ? "Welcome" : "Welcome back"}, {userData ? userData?.first_name : ""}
					</h2>}

					<div className="discover_details" style={{ marginTop: 10 }}>
						<img src={Fast} alt="order" style={{ width: 26, height: 26, flexShrink: 0 }} />
						<div className="discover_text">
							<p>
								Place order quickly, request delivery or pick up.
							</p>
						</div>
					</div>
					<div className="discover_details" style={{ marginTop: 10 }}>
						<img src={BookingIcon} alt="booking" style={{ width: 26, height: 26, flexShrink: 0 }} />
						<div className="discover_text">
							<p>
								Book appointments and reserve services with ease.
							</p>
						</div>
					</div>
					<div className="discover_details" style={{ marginTop: 10 }}>
						<img src={GiftCard1} alt="rewards" style={{ width: 26, height: 26, flexShrink: 0 }} />
						<div className="discover_text">
							<p>
								Collect loyalty points and rewards as you spend with us.
							</p>
						</div>
					</div>
					{message && <span style={{ color: danger ? "red" : "#000" }}>{messages}</span>}
					<Form form={signUpForm}>
						{/* First name + optional email shown when user not found */}
						{!showOTP && !isUserFound && (
							<>
								<Form.Item
									name="first_name"
									rules={[{ required: true, message: "Enter your first name to continue" }]}
									style={{ margin: "20px 0" }}>
									<Input
										prefix={<ContactsOutlined />}
										size="large"
										type="text"
										placeholder="First Name"
										onChange={(e) => setFirstName(e.target.value)}
										value={firstName}
									/>
								</Form.Item>
								{!contactInput.includes('@') && (
									<Form.Item
										name="email_signup"
										rules={[
											{ required: false },
											{ type: "email", message: "Please enter a valid email!" },
										]}
										style={{ margin: "20px 0" }}>
										<Input
											prefix={<MailOutlined />}
											size="large"
											type="email"
											placeholder="Email (Optional)"
											onChange={(e) => setEmail(e.target.value)}
											value={email}
										/>
									</Form.Item>
								)}
							</>
						)}
						{/* Email/Phone toggle input */}
						{!showOTP && (
							<Form.Item
								name="contact_input"
								rules={[{ required: true, message: "Enter your email or phone number to continue" }]}
								style={{ margin: "14px 0", position: 'relative' }}>
								{useEmailInput ? (
									<Input
										prefix={<MailOutlined />}
										suffix={
											<span
												onClick={() => { setUseEmailInput(false); setContactInput(''); }}
												style={{ padding: '4px 8px', fontSize: '12px', color: '#1890ff', cursor: 'pointer', userSelect: 'none' }}
											>
												Use Phone
											</span>
										}
										size="large"
										type="text"
										placeholder="Enter your email address"
										onChange={(e) => setContactInput(e.target.value)}
										value={contactInput}
									/>
								) : (
									<div style={{ position: 'relative' }}>
										<PhoneInput
											country={userCountry}
											value={contactInput}
											onChange={(phone) => {
												setContactInput(phone);
												setPhoneNo(`+${phone}`);
											}}
											inputStyle={{ width: '100%', height: '40px', fontSize: '14px', paddingLeft: '48px', paddingRight: '90px' }}
											buttonStyle={{ borderRight: 'none' }}
											containerStyle={{ width: '100%' }}
											enableSearch
											searchPlaceholder="Search country"
											placeholder="Enter phone number"
										/>
										<span
											onClick={() => { setUseEmailInput(true); setContactInput(''); }}
											style={{
												position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)',
												padding: '4px 8px', fontSize: '12px', color: '#1890ff', cursor: 'pointer',
												zIndex: 10, background: 'white', borderRadius: '4px', userSelect: 'none'
											}}
										>
											Use Email
										</span>
									</div>
								)}
							</Form.Item>
						)}
						{/* OTP input */}
						{showOTP && (
							<Form.Item
								name="OTP"
								rules={[{ required: true, message: "Enter the OTP sent to your contact" }]}
								style={{ margin: "20px 0" }}>
								<Input
									value={OTP}
									size="large"
									placeholder="Enter 6-digit OTP"
									maxLength={6}
									style={{ margin: 0, fontSize: 20, textAlign: "center", letterSpacing: 8 }}
									onChange={(e) => setOTP(e.target.value.replace(/\D/g, "").slice(0, 6))}
								/>
							</Form.Item>
						)}
						{showOTP && maskedContact && (
							<div style={{ marginBottom: 10, textAlign: "center", color: "#6B6A6A", fontSize: "14px" }}>
								Code sent to: {maskedContact}
							</div>
						)}
					</Form>

					{/* {value} */}
					{/* <p style={{ marginTop: 20, color: "#6B6A6A" }}>
						Our{" "}
						<Link style={{ color: "#000" }} to="/privacy">
							Privacy Policy
						</Link>
					</p> */}

					<div className="action_buttons" style={{ marginTop: "18px" }}>
						{!showOTP && isUserFound && (
							<Button
								type="primary"
								style={{ width: "277px", height: "46px" }}
								loading={loading}
								onClick={handleNewSignIn}
							>
								<span style={{ fontWeight: 600, fontSize: "18px" }}>Continue</span>
							</Button>
						)}
						{!showOTP && !isUserFound && (
							<Button
								type="primary"
								style={{ width: "277px", height: "46px" }}
								loading={loading}
								onClick={handleSignUpNewUser}
							>
								<span style={{ fontWeight: 600, fontSize: "18px" }}>Sign Up</span>
							</Button>
						)}
						{showOTP && (
							<Button
								type="primary"
								style={{ width: "277px", height: "46px" }}
								loading={loading}
								onClick={handleConfirmOTP}
								disabled={!OTP || OTP.length !== 6}
							>
								<span style={{ fontWeight: 600, fontSize: "18px" }}>Verify OTP</span>
							</Button>
						)}
						{showOTP && (
							<div style={{ display: 'flex', justifyContent: 'space-between', width: '277px', marginTop: 10 }}>
								<Button
									type="link"
									onClick={() => {
										setShowOTP(false);
										setOTP(null);
										localStorage.removeItem('otp_session');
									}}
									style={{ color: "#6B6A6A", padding: 0 }}
								>
									Cancel
								</Button>
								{(userData?.customer_id || userData?.user_id) ? (
									<Button
										type="link"
										onClick={() => handleSendNewOTP(userData.customer_id || userData.user_id, userData.otp_method, userData.otp_contact)}
										style={{ color: "#1890ff", padding: 0 }}
									>
										Resend OTP
									</Button>
								) : (
									<Button
										type="link"
										onClick={() => {
											setOTP(null);
											handleSignUpNewUser();
										}}
										style={{ color: "#1890ff", padding: 0 }}
									>
										Resend OTP
									</Button>
								)}
							</div>
						)}
					</div>
					{/* {!shouldSignIn && <p style={{color: "#000", textAlign:"center"}}>Already have an account, <span style={{cursor: "pointer"}} onClick={() => setShowSignIn(true)}>sign in</span> </p>}
					{shouldSignIn && <p style={{color: "#000", textAlign:"center"}}>Don't have an account, <span style={{cursor: "pointer"}} onClick={() => setShowSignIn(false)}>sign up</span> </p>} */}
					{/* <p style={{ marginTop: 20, color: "#6B6A6A", textAlign: "center" }}>
						Already have an account?
						<Button type="link" style={{ color: "#000" }} onClick={goNext}>
							Sign In
						</Button>
					</p> */}
				</div>

				<div className="sign_up_content">
					<div className="flex_center">
						<img
							style={{ width: 80 }}
							src={merchant?.image || LogoBlack}
							alt="merchant logo"
						/>
					</div>
					<h2
						className="title_text"
						style={{
							color: "#6B6A6A",
							marginTop: 20,
							fontWeight: 600,
							fontSize: "24px",
							textAlign: "center",
						}}>
						{merchant?.business_name || ""}
					</h2>
					<h2
						className="title_text"
						style={{
							color: "#000",
							fontWeight: 600,
							fontSize: "32px",
							textAlign: "center",
						}}>
						👋🏽 Welcome Back!
					</h2>

					<div className="discover_details">
						<img src={Compass} alt="compass" />
						<div className="discover_text">
							<p>Sign-in...</p>
							<p>
								to view the menu, send your orders, claim loyalty rewards and
								more...
							</p>
						</div>
					</div>

					<Form form={signInForm}>
						<Form.Item
							style={{ marginTop: 20 }}
							name="phone_number"
							rules={[
								{
									required: true,
									message: "Enter your phone number to continue",
								},
							]}>
							<PhoneInput
								inputClass="ant-col ant-form-item-control-wrapper ant-form-item-control ant-input ant-input-lg"
								inputStyle={{
									border: "0.5px solid #6B6A6A",
									height: "40px",
									width: "100%",
									borderRadius: 2,
								}}
								country={userCountry}
							/>
						</Form.Item>
						<Form.Item
							style={{ marginTop: 20 }}
							name="password"
							rules={[
								{
									required: true,
									message: "Enter your password to continue",
								},
							]}>
							<Input.Password
								size="large"
								placeholder="Enter password"
								iconRender={(visible) =>
									visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
								}
							/>
						</Form.Item>
					</Form>

					{/* <p style={{ marginTop: 20, color: "#6B6A6A" }}>
						Our{" "}
						<Link style={{ color: "#000" }} to="/privacy">
							Privacy Policy
						</Link>
					</p>
					<div className="action_buttons" style={{ marginTop: "3rem" }}>
						<Button
							type="primary"
							style={{ width: "277px", height: "50px" }}
							loading={isLoginLoading}
							onClick={handleLogin}>
							Continue
						</Button>
					</div>
					<p style={{ marginTop: 20, color: "#6B6A6A", textAlign: "center" }}>
						Don't have an account?
						<Button type="link" onClick={goPrev} style={{ color: "#000" }}>
							Sign Up
						</Button>
					</p> */}
				</div>
			</Carousel>
		</Modal>
	);
};

export default SigninModal;
